import {useState} from "react";
import {useSearchParams} from "react-router-dom";
import { LenderIqList } from "./LenderIqList";
import { LenderIqTwoPagerList } from "./LenderIqTwoPagerList";
const LENDERIQ_TABS = [
  {
    tabIndex: 0,
    tabId: "lender-book-a-demo",
    tabName: "Lender-Book a Demo",
  },
  {
    tabIndex: 1,
    tabId: "lender-2-pager-asset",
    tabName: "Lender-2-Pager-Asset",
  },
];

const LenderIqFramework = (): JSX.Element => {
  const [lenderIqTabs, setLenderIqTabs] = useState(LENDERIQ_TABS);
  const [searchParams, setSearchParams] = useSearchParams({tabIndex: "0"});

  const handleTabChange = (tabId: number) => {
    setSearchParams((params) => {
      params.set("tabIndex", JSON.stringify(tabId));
      return params;
    });
  };
  const tabIndex = searchParams.get("tabIndex");
  const parsedTabIndex = tabIndex ? JSON.parse(tabIndex) : 0;

  return (
    <div className="main-container podcasts">
      <div className="podcasts-tab">
        {lenderIqTabs.map((tab, index) => {
          const {tabIndex, tabId, tabName} = tab;

          return (
            <div
              key={tabId}
              className={`item ${tabIndex === parsedTabIndex ? "active" : ""}`}
              onClick={() => handleTabChange(tabIndex)}>
              {tabName}
            </div>
          );
        })}
      </div>
      <>
        {parsedTabIndex === 0 && <LenderIqList/>}
        {parsedTabIndex === 1 && <LenderIqTwoPagerList/>}
      </>
    </div>
  );
};

export default LenderIqFramework;
